<mat-toolbar class="toolbar">
  <span>Trripi</span>
  <button mat-icon-button class="example-icon" aria-label="Example icon-button with menu icon">
    <mat-icon>menu</mat-icon>
  </button>
</mat-toolbar>
